import { Config } from "../../../../../../../api/config";
export var InterWarehouseInwardKeys = {
    WarehouseInwardType: "WToWInward",
    WarehouseOutwardType: "WToWOutward",
    Paging: "interWarehouseInwardPaging",
    TransferOutward: 'TransferOutward',
    Get: "interWarehouseInwardGet",
    PriorityList: 'interWarehouseInwardPriorityList',
    InterWarehouseInwardDetails: 'interWarehouseInwardDetails',
    PartListByName: 'interWarehouseInwardPartListByName',
    InwardConfiguration: 'getInwardConfiguration',
    AllowInwardPartiallySave: 'AllowInwardPartiallySave',
    Create: 'Create',
    Upload: 'interWarehouseInwardUpload',
    AttachmentSystemName: 'StockTransferRequisition',
    UploadAttachmentSystemName: 'InventoryAttachment'
};
export var viewTypeOptions = ["My transfer", "All transfer"];
export var InwardStatusEnum = /*#__PURE__*/ function (InwardStatusEnum) {
    InwardStatusEnum["Completed"] = "Completed";
    return InwardStatusEnum;
}({});
export var InwardApiKeys = [InterWarehouseInwardKeys.Paging, InterWarehouseInwardKeys.TransferOutward, InterWarehouseInwardKeys.Get, InterWarehouseInwardKeys.PriorityList, InterWarehouseInwardKeys.InterWarehouseInwardDetails];
export var InterWarehouseInwaedPagingAPI = "".concat(Config.baseURL, "StockTransferRequisition/Paging");
export var InterWarehouseTransferInWardId = "".concat(Config.baseURL, "StockTransferRequisition/CompletedStockTransferRequisition");
export var InterWarehousePriorityListAPI = "".concat(Config.baseURL, "Priority/List");
export var InterWarehouseInwardWithDetails = function (id) { return "".concat(Config.baseURL, "StockTransferRequisition/").concat(id, "/StockTransferRequisitionWithDetails"); };
export var InterWarehouseInwardConfigurationAPI = "".concat(Config.baseURL, "OrganizationModulesItemSetting/GetByKey");
export var InterWarehouseInwardCreateAPI = "".concat(Config.baseURL, "StockTransferRequisition/CreateInwardOutwardWToWProcess");
export var InterWarehouseInwardPartDetailsMandatoryFeilds = {
    'ActualRecievedQty': 'ActualRecievedQty'
};
